import React from 'react';

export default function VisionsMission() {
  return (
    <section className="pt-28 pb-32 px-4 text-white bg-[#060b29] min-h-screen">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-20">Vision & Mission</h1>

        {/* Vision */}
        <div className="mb-20">
          <h2 className="text-purple-300 mb-4" style={{ fontSize: '32px' }}>Our Vision</h2>
          <p style={{ fontSize: '20px' }} className="text-gray-300 leading-relaxed">
            At PipPlus Tech, our vision is to create a next-generation digital ecosystem where algorithmic trading,
            financial intelligence, and automated strategy execution converge. We aim to transform how traders engage with
            the forex, crypto, and commodities markets — building a smarter, faster, and more efficient trading experience
            that’s accessible to all.
          </p>
        </div>

        {/* Mission */}
        <div>
          <h2 className="text-purple-300 mb-4" style={{ fontSize: '32px' }}>Our Mission</h2>
          <p style={{ fontSize: '20px' }} className="text-gray-300 leading-relaxed">
            Our mission is to empower individuals and institutions through intelligent automation. As the world transitions
            into the digital economy of Industry 4.0, PipPlus Tech is committed to pioneering innovations in algo trading,
            risk-managed execution, and real-time signal delivery. We strive to bridge the gap between complex financial systems
            and everyday investors — making smart trading tools universally accessible and remarkably simple.
          </p>
        </div>
      </div>
    </section>
  );
}
